<template>
  <span
    ref="backToTop"
    tabindex="-1"
  />
  <ul
    ref="skipLinks"
    class="skip-links fixed z-max bg-white rounded-borders q-ma-sm q-pa-sm fixed-top-left no-pointer-events"
    tabindex="-1"
  >
    <li class="q-pa-xs">
      <a
        class="text-bold"
        href="#"
        @click.stop.prevent="focusSkipLinkTarget('content')"
      >
        {{ t('SKIP_LINKS.SKIP_TO_CONTENT') }}
      </a>
    </li>
    <li class="q-pa-xs">
      <a
        class="text-bold"
        href="#"
        @click.stop.prevent="focusSkipLinkTarget('menu')"
      >
        {{ t('SKIP_LINKS.SKIP_TO_MENU') }}
      </a>
    </li>
  </ul>
</template>
<script setup>
/* See guides on skip links
    - https://marcus.io/blog/20200127-improved-accessible-routing-vuejs
    - https://vuejs.org/guide/best-practices/accessibility#skip-link
    - https://www.w3.org/WAI/WCAG21/Understanding/bypass-blocks
 */

import { nextTick, useTemplateRef, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import { useDetailService } from '@/messages/services.js'

const { t } = useI18n()

const route = useRoute()
const backToTop = useTemplateRef('backToTop')

watch(() => route.path, () => backToTop.value?.focus(), { immediate: true })

function focusSkipLinkTarget (name) {
  // Find all the matching targets, and select the last one
  // This is assumed to be the most specific
  // e.g. if the main content is in the detail navigation on the right we
  // want to go there... (hopefully!)
  const targets = [...document.querySelectorAll('.skip-link-target-' + name)]
  if (targets.length > 0) {
    targets[targets.length - 1].focus()
  }
}

const { isDetailActive } = useDetailService()

// When the detail gets opened, immediately jump focus there, as the user
// has just done something to open it, as if they had opened a dialog
watch(isDetailActive, (current, prev) => {
  if (!prev && current) {
    nextTick(() => {
      focusSkipLinkTarget('detail-sidebar')
    })
  }
})

</script>
<style scoped lang="sass">
.skip-links
  list-style: none
  opacity: 0
  &:focus-within
    opacity: 1

</style>
